import { createIntl } from 'react-intl';
import { DefaultElements, ResourceAliases } from '../placeholders';
export const createI18n = (config, cache) => {
    const intl = createIntl({
        ...config,
        defaultRichTextElements: {
            ...DefaultElements,
            ...config.defaultRichTextElements,
        },
    }, cache);
    const aliases = ResourceAliases(intl);
    return {
        ...intl,
        formatMessage: (descriptor, values, opts) => {
            return intl.formatMessage(descriptor, { ...aliases, ...values }, opts);
        },
    };
};
//# sourceMappingURL=createI18n.js.map